import React, { useEffect, useState } from "react";
import "./ProductGrid.css";
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { FaArrowRightLong } from "react-icons/fa6";
// import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import { TbShoppingBag } from "react-icons/tb";
import { addToCart, removeFromCart, setCart, setTotalItems, setTotalPrice, setCartId, } from "../../store/cartSlice";
import { useDispatch, useSelector } from "react-redux";
// import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
// import { addToCart as addToCartRedux } from "../../store/cartSlice";
import { addToWishlist, removeFromWishlist, incrementWishlistCount, decrementWishlistCount } from "../../store/wishlistSlice";
import { getWithoutTokenAPI, postWithTokenAPI } from "../../util/Api";
import ProductCardpop from "../Product-quick-view/quickview";
import LoginPopup from "../../Components/Loginpopup/Loginpop";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactStars from "react-rating-stars-component";
  import AOS from "aos";
import "aos/dist/aos.css";

const ProductGrid = () => {
  const [productData, setProductData] = useState([]);
  const [topRatedProducts, setTopRatedProducts] = useState([]);
  const [bestseller, topbestseller] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isLoginPopupOpen, setLoginPopupOpen] = useState(false);
  const [error, setError] = useState(null);
  const [cartSuccessMessage, setCartSuccessMessage] = useState("");
  const [addingToCart, setAddingToCart] = useState(false);
  const userId = useSelector((state) => state.auth?.auth?._id);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const accessToken = useSelector((state) => state.auth?.auth?.access_token);
  const isLoggedIn = useSelector((state) => state.auth?.isLoggedIn);
  const wishlistItems = useSelector((state) => state.wishlist.items);
  const [isLiked, setIsLiked] = useState(false);


useEffect(() => {
  AOS.init({ duration: 1000, once: true });
}, []);


  const toggleLike = () => {
    setIsLiked(!isLiked);
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const queryParams = userId ? `?user_id=${userId}` : '';
        const response = await getWithoutTokenAPI(`/product/hot_deals${queryParams}`);
        if (response?.statusCode === 200) {
          let products = response.data?.hot_deals || [];
          
          if (isLoggedIn && wishlistItems) {
            products = products.map((product) => ({
              ...product,
              sellerName: product.seller_name || "Unknown Seller",
              wish_status: wishlistItems.some(item => item._id === product._id) || product.wish_status || false
            }));
          } else {
            products = products.map((product) => ({
              ...product,
              sellerName: product.seller_name || "Unknown Seller",
              wish_status: product.wish_status || false
            }));
          }
          setProductData(products);
        }
      } catch (error) {
        console.error("Failed to fetch products:", error);
      }
    };

    fetchProducts();
  }, [isLoggedIn, userId, wishlistItems]);


  useEffect(() => {
    const fetchProductstop = async () => {
      try {
        const queryParams = userId ? `?user_id=${userId}` : '';

        const response = await getWithoutTokenAPI(`/product/find-all?best_seller=true${queryParams}`);
        if (response?.statusCode === 200) {
          let products = response.data?.Product || [];

          if (isLoggedIn && wishlistItems) {
            products = products.map((product) => ({
              ...product,
              sellerName: product.seller_id?.name || "Unknown Seller",
              wish_status: wishlistItems.some(item => item._id === product._id) || product.wish_status || false
            }));
          } else {
            products = products.map((product) => ({
              ...product,
              sellerName: product.seller_id?.name || "Unknown Seller",
              wish_status: product.wish_status || false
            }));
          }
          setTopRatedProducts(products);
        }
      } catch (error) {
        console.error("Failed to fetch products:", error);
      }
    };

    fetchProductstop();
  }, [isLoggedIn, userId, wishlistItems]);


  useEffect(() => {
    const fetchProductsbest = async () => {
      try {
        const queryParams = userId ? `?user_id=${userId}` : '';

        const response = await getWithoutTokenAPI(`/product/top_rating${queryParams}`);
        if (response?.statusCode === 200) {
          let products = response.data?.top_rating || [];

          if (isLoggedIn && wishlistItems) {
            products = products.map((product) => ({
              ...product,
              sellerName: product.seller_info.name || "Unknown Seller",
              wish_status: wishlistItems.some(item => item._id === product._id) || product.wish_status || false
            }));
          } else {
            products = products.map((product) => ({
              ...product,
              sellerName: product.seller_info.name || "Unknown Seller",
              wish_status: product.wish_status || false
            }));
          }
          topbestseller(products);
        }
      } catch (error) {
        console.error("Failed to fetch products:", error);
      }
    };

    fetchProductsbest();
  }, [isLoggedIn, userId, wishlistItems]);
  // const requireLogin = () => {
  //   if (!isLoggedIn || !accessToken) {
  //     setLoginPopupOpen(true);
  //     return false;
  //   }
  //   return true;
  // };



  const closeLoginPopup = () => {

    setLoginPopupOpen(false);

  };


 
  const handleAddToCart = async (cartItem) => {
    if (!accessToken) {
      setLoginPopupOpen(true);
      return;
    }
    if (!cartItem?._id) return;

    if (addingToCart) return;
    setAddingToCart(true);
    setError(null);

    try {
      const payload = {
        cart: [
          {
            product_id: cartItem._id,
            quantity: cartItem.quantity > 0 ? cartItem.quantity : 1,
          },
        ],
      };

      const response = await postWithTokenAPI(accessToken, "/cart/add", payload);

      // 🧹 Case: Cart emptied
      if (
        response?.statusCode === 200 &&
        response?.message === "Product removed and cart deleted as it became empty"
      ) {
        dispatch(setCart([]));
        dispatch(setTotalItems(0));
        dispatch(setTotalPrice(0));
        dispatch(setCartId(null));
        toast.info("Item removed and cart is now empty.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          toastId: `removed-${cartItem._id}`,
          theme: "light",
        });
      }

      // ✅ Case: Product added successfully
      else if (response?.statusCode === 200 && response.data?.cart) {
        const addedItem = response.data.cart;

        dispatch(
          addToCart({
            id: addedItem.product_id,
            price: addedItem.price,
            quantity: addedItem.quantity,
            name: addedItem.name,
            image: addedItem.image,
          })
        );

        toast.success("Item added to cart successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          toastId: `cart-${cartItem._id}`,
          theme: "light",
        });
      }

      // ❌ Failure case
      else {
        toast.error("Failed to add item to cart.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          toastId: `error-${cartItem._id}`,
          theme: "light",
        });
      }
    } catch (error) {
      console.error("Add to cart error:", error);
      toast.error("Something went wrong. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        toastId: `error-${cartItem._id}`,
        theme: "light",
      });
    } finally {
      setAddingToCart(false);
    }
  };

  const handleWishlistClick = async (e, product) => {
    e.stopPropagation();

    if (!isLoggedIn || !accessToken) {
      setLoginPopupOpen(true);
      return;
    }

    try {
      const payload = {
        product_id: product._id,
        category_id: product.category_id || product.category?._id,
      };

      const response = await postWithTokenAPI(accessToken, "/wishlist/add", payload);

      if (response?.statusCode === 200) {
        // Update the product's wish_status in all product lists
        setProductData(prevList =>
          prevList.map(p =>
            p._id === product._id
              ? { ...p, wish_status: true }
              : p
          )
        );
        setTopRatedProducts(prevList =>
          prevList.map(p =>
            p._id === product._id
              ? { ...p, wish_status: true }
              : p
          )
        );
        topbestseller(prevList =>
          prevList.map(p =>
            p._id === product._id
              ? { ...p, wish_status: true }
              : p
          )
        );
        dispatch(addToWishlist(product));
        dispatch(incrementWishlistCount());
        toast.success('Item added to wishlist successfully!');
      } else if (response?.statusCode === 406) {
        // Update the product's wish_status in all product lists
        setProductData(prevList =>
          prevList.map(p =>
            p._id === product._id
              ? { ...p, wish_status: false }
              : p
          )
        );
        setTopRatedProducts(prevList =>
          prevList.map(p =>
            p._id === product._id
              ? { ...p, wish_status: false }
              : p
          )
        );
        topbestseller(prevList =>
          prevList.map(p =>
            p._id === product._id
              ? { ...p, wish_status: false }
              : p
          )
        );
        dispatch(removeFromWishlist(product._id));
        // dispatch(decrementWishlistCount());
        toast.error('Item removed from wishlist');
      } else {
        console.warn("Failed to update wishlist:", response);
        toast.error('Failed to update wishlist');
      }
    } catch (error) {
      console.error("Error updating wishlist:", error);
      toast.error('Error updating wishlist');
    }
  };

  const handleQuickView = (product, event) => {
    event.stopPropagation();
    setSelectedProduct(product);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setSelectedProduct(null);
  };

  const handleFindParticular = (productId) => {
    // Find the product from our existing productData
    const product = productData.find(p => p._id === productId);
    if (product) {
      navigate(`/product?_id=${productId}&seller_name=${product.sellerName}&product_name=${product.name}&wish_status=${product.wish_status || false}`);
    }
  };

  const starRatingConfig = {
    size: 20,
    value: 0,
    edit: false,
    activeColor: "#ffd700",
    color: "#d4d4d4",
    isHalf: true,
    count: 5,
    a11y: true,
    onChange: () => { },
    classNames: {
      container: "star-rating-container",
      star: "star-rating-star"
    }
  };

  // const renderProductCard = (product) => {
  //   // Use product's wish_status instead of checking wishlistItems
  //   const isInWishlist = product.wish_status;

  //   return (
  //     <>
  //       <div
  //         className={`card product-card-two d-flex flex-row mb-3`}
  //         key={product._id}
  //         onClick={() => handleFindParticular(product._id)}
  //       >
  //         <img
  //           src={product.product_image?.[0]}
  //           className="product-image-two"
  //           alt={product.name}
  //         />
  //         <div className="card-body  productgrid-product-card-body">
  //           <h5 className="card-title ff-poppins fw-400 fs-14 productgrid-product-cards ">
  //             {product.name}
  //           </h5>
  //           <span
  //             className="ff-poppins fs-12"
  //             style={{ color: "#00b207" }}
  //           >
  //             {product.sellerName}
  //           </span>
  //           <p className="card-text ff-poppins fw-500 fs-16">
  //             Ksh {product.discount_price?.toFixed(2) || "N/A"}
  //           </p>
  //           <div className="product-rating">
  //             <ReactStars
  //               {...starRatingConfig}
  //               value={product.average_rating || 0}
  //               key={`stars-${product.average_rating}`}
  //             />
  //           </div>

  //           <div className="product-card-btn-group">
  //             <button
  //               className="btn product-icons-cart"
  //               style={{
  //                 backgroundColor: "#00b207",
  //                 color: "#ffffff",
  //                 padding: "4px 8px",
  //                 borderRadius: "55%",
  //                 border: "none",
  //                 cursor: "pointer"
  //               }}
  //               onClick={(e) => {
  //                 e.stopPropagation();
  //                 handleAddToCart({ ...product, quantity: 1 });
  //               }}
  //             >
  //               <TbShoppingBag size={20} />
  //             </button>
  //             <button
  //               className="btn product-icons-eye"
  //               onClick={(e) => handleQuickView(product, e)}
  //             >
  //               <MdOutlineRemoveRedEye size={20} />
  //             </button>
  //             <button
  //               className={`btn product-icons-eye ${isInWishlist ? 'wishlist-active' : ''}`}
  //               onClick={(e) => {
  //                 e.stopPropagation();
  //                 handleWishlistClick(e, product);
  //               }}
  //             >
  //               {isInWishlist ? (
  //                 <FaHeart style={{ color: '#00b207', fontSize: '16px' }} />
  //               ) : (
  //                 <FaRegHeart style={{ color: '#1a1a1a', fontSize: '16px' }} />
  //               )}
  //             </button>
  //           </div>
  //         </div>
  //       </div>
  //     </>
  //   );
  // };
const renderProductCard = (product, index) => {
    // Use product's wish_status instead of checking wishlistItems
    const isInWishlist = product.wish_status;

    return (
      <>
        <div
          className={`card product-card-two d-flex flex-row mb-3`}
          key={product._id}
          onClick={() => handleFindParticular(product._id)}
          data-aos="fade-up" // Base animation
          data-aos-delay={index * 100} // Stagger animations
          data-aos-duration="600" // Animation duration
          data-aos-easing="ease-in-out" // Smooth easing
          data-aos-once="true" // Only animate once
        >
          <img
            src={product.product_image?.[0]}
            className="product-image-two"
            alt={product.name}
            data-aos="zoom-in" // Separate image animation
            data-aos-delay={index * 100 + 200}
            data-aos-duration="500"
          />
          <div 
            className="card-body productgrid-product-card-body"
            data-aos="fade-left" // Content animation
            data-aos-delay={index * 100 + 300}
            data-aos-duration="500"
          >
            <h5 className="card-title ff-poppins fw-400 fs-14 productgrid-product-cards">
              {product.name}
            </h5>
            <span
              className="ff-poppins fs-12"
              style={{ color: "#00b207" }}
            >
              {product.sellerName}
            </span>
            <p className="card-text ff-poppins fw-500 fs-16">
              Ksh {product.discount_price?.toFixed(2) || "N/A"}
            </p>
            <div className="product-rating">
              <ReactStars
                {...starRatingConfig}
                value={product.average_rating || 0}
                key={`stars-${product.average_rating}`}
              />
            </div>

            <div 
              className="product-card-btn-group"
              data-aos="fade-up"
              data-aos-delay={index * 100 + 400}
              data-aos-duration="300"
            >
              <button
                className="btn product-icons-cart"
                style={{
                  backgroundColor: "#00b207",
                  color: "#ffffff",
                  padding: "4px 8px",
                  borderRadius: "55%",
                  border: "none",
                  cursor: "pointer"
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleAddToCart({ ...product, quantity: 1 });
                }}
              >
                <TbShoppingBag size={20} />
              </button>
              <button
                className="btn product-icons-eye"
                onClick={(e) => handleQuickView(product, e)}
              >
                <MdOutlineRemoveRedEye size={20} />
              </button>
              <button
                className={`btn product-icons-eye ${isInWishlist ? 'wishlist-active' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleWishlistClick(e, product);
                }}
              >
                {isInWishlist ? (
                  <FaHeart style={{ color: '#00b207', fontSize: '16px' }} />
                ) : (
                  <FaRegHeart style={{ color: '#1a1a1a', fontSize: '16px' }} />
                )}
              </button>
            </div>
          </div>
        </div>
      </>
    );
  };
  return (
    <>
    



      {isLoginPopupOpen && <LoginPopup onClose={closeLoginPopup} />}

  <div className="product-design-bg">
<div className="container-fluid design-bg">
      <div className="container-fluid product-grid-container product-content-position p-md-5">
  <div className="row align-items-md-center">

    <div className="col-lg-12">
     <div className="row mt-3">

  {/* Hot Deals */}
  {productData.length > 0 && (
    <div className="col-md-4" data-aos="fade-up" data-aos-delay="100">
      <h5 className="section-title" data-aos="fade-right"> Hot Deals</h5>
      {productData.slice(0, 3).map((item, idx) => (
        <div data-aos="zoom-in" data-aos-delay={200 + idx * 100} key={idx}>
          {renderProductCard(item)}
        </div>
      ))}
    </div>
  )}

  {/* Best Sellers */}
  {topRatedProducts.length > 0 && (
    <div className="col-md-4" data-aos="fade-up" data-aos-delay="200">
      <h5 className="section-title" data-aos="fade-right"> Best Sellers</h5>
      {topRatedProducts.slice(0, 3).map((item, idx) => (
        <div data-aos="zoom-in" data-aos-delay={300 + idx * 100} key={idx}>
          {renderProductCard(item)}
        </div>
      ))}
    </div>
  )}

  {/* Top Rated */}
  {bestseller.length > 0 && (
    <div className="col-md-4" data-aos="fade-up" data-aos-delay="300">
      <h5 className="section-title" data-aos="fade-right"> Top Rated</h5>
      {bestseller.slice(0, 3).map((item, idx) => (
        <div data-aos="zoom-in" data-aos-delay={400 + idx * 100} key={idx}>
          {renderProductCard(item)}
        </div>
      ))}
    </div>
  )}

</div>

    </div>




  </div>

  {/* Product Quick View Popup */}
  {isPopupOpen && selectedProduct && (
    <ProductCardpop
      isOpen={isPopupOpen}
      onClose={closePopup}
      selectedProductId={selectedProduct._id}
      productDetails={selectedProduct}
    />
  )}
</div>
</div>
  </div>


    </>

  );
};

export default ProductGrid;